module.exports = __webpack_public_path__ + "static/media/CO.7e342e02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/CO.svg
// module id = 2132
// module chunks = 7